import { enableProdMode, LOCALE_ID, ErrorHandler, importProvidersFrom } from '@angular/core';

import { environment } from 'environments/environment';
import { ObjetoService } from './app/core/services/objeto.service';
import { ServicoService } from './app/core/services/servico.service';
import { UsuarioService } from './app/core/services/usuario.service';
import { OABCookieService } from './app/core/services/oab-cookie.service';
import { OrganizacaoService } from './app/core/services/organizacao.service';
import { UtilService } from './app/core/services/util.service';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProgressInterceptor } from './app/core/interceptors/progress.interceptor';
import { AuthInterceptor } from './app/core/interceptors/auth.interceptor';
import { ApplicationErrorHandler } from './app/app.error-handler';
import { AuthService } from './app/core/auth/auth.service';
import { AuthGuard } from './app/core/auth/auth.guard';
import { MenuRouteGuard } from './app/core/auth/menu-route.guard';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { CookieModule } from 'ngx-cookie';
import { ToastrModule } from 'ngx-toastr';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routing';

if (environment.production) {
    enableProdMode();
}

// LOCALE_ID é 'pt-BR'; o Angular só embute en-US por padrão, então registramos os
// dados do locale pt para o DatePipe/number/currency funcionarem (evita NG0701).
registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        importProvidersFrom(
            CookieModule.forRoot(),
            ToastrModule.forRoot({
                timeOut: 3000,
                positionClass: 'toast-bottom-center',
                preventDuplicates: true
            }),
            PaginationModule.forRoot(),
            TypeaheadModule.forRoot(),
            CollapseModule.forRoot(),
            ClipboardModule,
            NgxCaptchaModule
        ),
        ObjetoService,
        ServicoService,
        UsuarioService,
        OABCookieService,
        OrganizacaoService,
        UtilService,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: HTTP_INTERCEPTORS, useClass: ProgressInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ApplicationErrorHandler },
        AuthService,
        AuthGuard,
        MenuRouteGuard
    ]
});
